import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiConfig, ApiDomain, ApiVersion } from '@contracts';
import { Observable } from 'rxjs';
import {
  ApiDeleteRequest,
  ApiGetRequest,
  ApiMutationRequest,
  QueryParams,
} from './api-client.types';

@Injectable({ providedIn: 'root' })
export class ApiCilent {
  constructor(
    private http: HttpClient,
    @Inject(API_CONFIG) private cfg: ApiConfig,
  ) {}

  private joinUrl(...parts: string[]): string {
    return (
      parts
        //   .filter(Boolean)
        //   .map((part, index) =>
        //     index === 0 ? part.replace(/\+$/g, '') : part.replace(/^\/+|\/+$/g, ''),
        //   )
        .join('/')
    );
  }

  private resolveVersion(version: ApiVersion): string {
    return this.cfg.apiVersion[version];
  }
  
  private resolveDomain(domain: ApiDomain): string {
    return this.cfg.apiUrl[domain];
  }

  private buildUrl(
    path: string,
    domain: ApiDomain = 'core',
    version: ApiVersion = 'v1',
  ): string {
    return this.joinUrl(
      this.resolveDomain(domain),
      this.resolveVersion(version),
      path,
    );
  }

  private buildParams(query?: QueryParams): HttpParams | undefined {
    if (!query) return undefined;

    let params = new HttpParams();

    Object.entries(query).forEach(([key, value]) => {
      if (value === null || value === undefined) return;

      if (Array.isArray(value)) {
        value.forEach((item) => {
          params = params.append(key, String(item));
        });
        return;
      }

      params = params.set(key, String(value));
    });

    return params;
  }

  get<TResponse>(req: ApiGetRequest): Observable<TResponse> {
    const { path, query, options, domain = 'core', version = 'v1' } = req;
    return this.http.get<TResponse>(this.buildUrl(path, domain, version), {
      ...options,
      params: this.buildParams(query),
    });
  }

  post<TResponse, TBody = unknown>(
    req: ApiMutationRequest<TBody>,
  ): Observable<TResponse> {
    const { path, body, query, domain = 'core', options, version = 'v1' } = req;
    return this.http.post<TResponse>(
      this.buildUrl(path, domain, version),
      body,
      {
        ...options,
        params: this.buildParams(query),
      },
    );
  }

  patch<TResponse, TBody = unknown>(
    req: ApiMutationRequest<TBody>,
  ): Observable<TResponse> {
    const { path, body, query, domain = 'core', options, version = 'v1' } = req;
    return this.http.patch<TResponse>(
      this.buildUrl(path, domain, version),
      body,
      {
        ...options,
        params: this.buildParams(query),
      },
    );
  }

  put<TResponse, TBody = unknown>(
    req: ApiMutationRequest<TBody>,
  ): Observable<TResponse> {
    const { path, body, query, options, domain = 'core', version = 'v1' } = req;
    return this.http.put<TResponse>(
      this.buildUrl(path, domain, version),
      body,
      {
        ...options,
        params: this.buildParams(query),
      },
    );
  }

  delete<TResponse>(req: ApiDeleteRequest): Observable<TResponse> {
    const { body, path, query, options, version = 'v1', domain = 'core' } = req;

    return this.http.delete<TResponse>(this.buildUrl(path, domain, version), {
      ...options,
      params: this.buildParams(query),
      body,
    });
  }
}
